export default __webpack_public_path__ + "static/media/bg-lg.21b68b42.png";